<template lang="html">
	<div id="page__operations-toolbar" class="toolbar-search__container">
		<div class="toolbar-search">
			<z-select v-model="customFilter.type" light v-on:input="onCustomFilter">
				<option value="" selected>Тип (все)</option>
				<option value="1">Приход</option>
				<option value="2">Расход</option>
			</z-select>
			
            <z-select id="company_id" name="company_id" v-model="customFilter.company_id" light v-on:input="onCustomFilter">
                <option value="" selected>Получатель (все)</option>
                <option v-for="company in companies" v-bind:value="company.id" v-bind:key="('operations-toolbar__company-' + company.id)">{{ company.name }}</option>
            </z-select>

			<input class="toolbar-search__input" id="toolbar-search__input" type="text" placeholder="Поиск..." v-model="filter.search" v-on:keyup.enter="onFilter"/>
			<z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-on:click="onReset" v-if="filter.search && filter.search.length || hasCustomFilter"></z-icon-button>
			<z-icon-button v-bind:icon="['fa', 'gear']" rounded v-on:click="toggleFilter" primary-light ></z-icon-button> 
		</div>
		<div class="dropdown md-elevation-2" v-if="filterSettings" v-click-outside="hideFilterSettings">
			<div class="search-md-menu-container">
                <div class="md-layout filter-container">

					<div class="md-layout-item md-size-100">
          				<div class="md-layout">
                            <label class="md-layout-item md-size-20 center-layout">Дата создания</label>
                            <z-date class="md-layout-item md-size-40" v-model="customFilter.date_from" no-margin v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата создания от"></z-date>
                            <z-date class="md-layout-item md-size-40" v-model="customFilter.date_to"   no-margin v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата создания до"></z-date>
						</div>
					</div>

                    <div class="md-layout-item md-size-100">
                        <div class="md-layout">
                            <label class="md-layout-item md-size-20 center-layout">Дата по документу</label>
                            <z-date class="md-layout-item md-size-40" v-model="customFilter.create_date_from" no-margin v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата по документу от"></z-date>
                            <z-date class="md-layout-item md-size-40" v-model="customFilter.create_date_to"   no-margin v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата по документу до"></z-date>
                        </div>
                    </div>

                    <label class="center-layout md-layout-item md-size-20">Контрагент</label>
                    <div class="md-layout-item md-size-80">
                        <z-input-autocomplete
                            v-model="customFilter.customer_id"
                            v-bind:default="customFilter.customer_label"
                            v-on:select="onSelectCustomer"
                            v-on:clear="onClearCustomer"
                            placeholder="ИНН/Паспорт"
                            name="operations_filter_customer"
                            id="operations_filter_customer"
                            display-property-list="label"
                            display-property="label"
                            property="id"
                            v-bind:callback="searchCustomer"
                        ></z-input-autocomplete>
                    </div>

                    <div class="md-layout-item md-size-100 md-alignment-bottom-right dropdown-button-container">
                        <z-button class="md-dense md-primary small" fit-content v-on:click="onCustomFilter">Применить</z-button>
                    </div>
                </div>
			</div>
		</div>
	</div>
</template>
<script>
	import ZDate   from '@/components/ZDate';
    import ZButton from '@/components/ZButton.vue';
    import ZSelect from '@/components/ZSelect';
	import ZIconButton  from '@/components/ZIconButton.vue';
    import ZInputAutocomplete from '@/components/ZInputAutocomplete';
    import autocomplete from '@/components/autocomplete'
    import ClickOutside from 'vue-click-outside';
	export default {
		components: { ZSelect, ZDate, ZIconButton, ZButton, ZInputAutocomplete, autocomplete },
		directives: { ClickOutside },
		data() {
            return {
                filterSettings: false,
                filter: {
                    search: null,
                },
                filterDefault: {
                    search: null,
                },
                customFilter: {
                    type: null,
                    customer_id: null,
                    customer_label: null,
                    company_id:  null,
                    date_to:     null,
                    date_from:   null,
                    create_date_to:   null,
                    create_date_from: null,
                },
                customFilterDefault: {
                    type: null,
                    customer_id: null,
                    customer_label: null,
                    company_id:  null,
                    date_to:     null,
                    date_from:   null,
                    create_date_to:   null,
                    create_date_from: null,
                },
            }
		},
		created() {
			this.resolveQueryFilter();
			this.$root.$emit('refresh-table', 'operations');
            if (!this.companies || !this.companies.length) this.getCompanies();
		},
		computed: {
			hasCustomFilter() {
				return (this.$route.query && this.$route.query.custom_filter);
			},
            /**
             * Список компаний
             * @returns Array
             */            
             companies() {
                return this.$store.state.companies.companies;
            },
		},
		watch: {
			'filter.search'(val) {
				const search = val;
				setTimeout(() => {
					if (!this.filter.search || !this.filter.search.length) return this.onReset()
					if (this.filter.search == search) this.onFilter()
				}, 1000)
			}
		},
		methods: { 
			/**
             * Подставление фильтра при перезагрузке
             */
            resolveQueryFilter() {
                this.filter       = Object.assign({}, this.filterDefault)
				this.customFilter = Object.assign({}, this.customFilterDefault)

				if (this.$route.query && this.$route.query.filter)
					this.filter = Object.assign({}, JSON.parse(this.$route.query.filter))
				
				if (this.$route.query && this.$route.query.custom_filter)
					this.customFilter = JSON.parse(this.$route.query.custom_filter);
            },
			/**
			 * Переключение выпадашки
			 */
			toggleFilter() {
				this.filterSettings = !this.filterSettings;
			},
			/**
			 * Закрытие выпадашки
			 */
			hideFilterSettings() {
				this.filterSettings = false;
			},
			/**
			 * Сброс фильтра
			 */
			onReset() {
				this.filter = Object.assign({}, this.filterDefault)
				this.resetCustomFilter();0
			},
			/**
			 * Кастомный фильтр
			 */
			onCustomFilter() {
				this.filterSettings = false;
				const query = Object.assign({}, this.$route.query);
				query.custom_filter = JSON.stringify(this.customFilter);

				this.$router.push({ name: this.$route.name, params: this.$route.params, query: query });
				this.$root.$emit('refresh-table', 'operations');
			},
			/**
			 * Сброс кастомного фильтра
			 */
			resetCustomFilter() {
				this.customFilter = this.customFilterDefault
				this.$router.push({ name: this.$route.name, params: this.$route.params, query: {}});
				this.$root.$emit('refresh-table', 'operations');  
			},
			/**
			 * Фильтрация
			 */
			async onFilter() {
				const query = Object.assign({}, this.$route.query);
				query.filter = JSON.stringify(this.filter);	

				this.$router.push({ name: this.$route.name, params: this.$route.params, query: query });
				this.$root.$emit('refresh-table', 'operations');
			},

            onSelectCustomer(id, customer) {
                if (!customer || !customer.label) return
                this.customFilter.customer_label = customer.label
            },

            onClearCustomer() {
                this.customFilter.customer_id = null
                this.customFilter.customer_label = null
            },

            searchCustomer(search = '') {
                if (!search) return new Promise((resolve, reject) => resolve([]));
                return Promise.all([
                    this.searchCustomerByInn(search),
                    this.searchCustomerByPassport(search)
                ]).then(([FL, UL]) => Object.assign([], FL, UL))
            },

            searchCustomerByInn(inn = '') {
                if (!inn || (inn.length != 10 && inn.length != 12)) return new Promise((resolve, reject) => resolve([]));
                return this.$store.dispatch('customers/searchCustomers', {search: inn, type: 4}).then(customers => {
                    if (customers && customers.data && Array.isArray(customers.data)) customers = Object.assign([], customers.data)
                    
                    if (!customers || !customers.length) return [];
                    return customers.map(item => {
                        item.label = item.inn  + ': ' + item.name;
                        return item;
                    });
                }, () => []);
            },

            searchCustomerByPassport(passport = '') {
                if (!passport || passport.replace(/\D/g, "").length != 10) return new Promise((resolve, reject) => resolve([]));
                return this.$store.dispatch('customers/searchCustomers', { search: passport, type: 2 }).then(customers => {
                    if (customers && customers.data && Array.isArray(customers.data)) customers = Object.assign([], customers.data)

                    if (!customers || !customers.length) return [];
                    return customers.map(item => {
                        item.label = (item.passport_number ? (item.passport_number + ': ') : '') + item.name;
                        return item;
                    });
                }, () => []);
            },

            /**
             * Получает список компаний - исполнителей из API
             * @returns Promise
             */
             getCompanies() {
                return this.$store.dispatch('companies/getCompanies');
            },
		}
	}
</script>
<style lang="sass">
  .deals-search-setting
    max-height: 90vh
    max-width: 100%
    .filter-container
      width: 100%
      .center-layout
        display: flex
        align-items: center
        justify-content: flex-start
      .with-pr
        padding-right: 15px
</style>


// WEBPACK FOOTER //
// OperationsToolbar.vue?5530be9b